import React from "react";
import { RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { ToastContainer } from "./components/ui/ToastContainer";
import { QueryProvider } from "./core/QueryProvider";
import { router } from "./router";

function App() {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <RouterProvider router={router} />
        <ToastContainer />
      </QueryProvider>
    </ErrorBoundary>
  );
}

export default App;
